import { EnvironmentInjector, inject, Injector } from '@angular/core';
import { Modal2, ResolvableModal } from '../abstraction/modal';
import { ModalService } from '../modal.service';
import { Dismissed, ModalConfig } from '../types/modal-config';

async function modal<TModal extends Modal2, TResult>(
  modalService: ModalService,
  config: ModalConfig<TModal>,
  injector: Injector
): Promise<TModal extends ResolvableModal<TResult> ? TResult | Dismissed : Dismissed> {
  const modalConfig = {
    component: config.component,
    dismiss: config.dismiss,
    title: config.title,
    subtitle: config.subtitle,
    template: config.template,
    templateContext: config.templateContext,
    priority: Number.POSITIVE_INFINITY,
    class: config.class,
    contentClass:
      config?.separateContentSection === true
        ? 'bg-surface-secondary border-t mt-2'
        : undefined,
    data: config.data,
    injector: config.injector ?? injector,
    dismissOnNavigation: config.dismissOnNavigation ?? true,
  };
  return await modalService.open(modalConfig);
}

type ExtractResult<Type> =
  Type extends ResolvableModal<infer X> ? X | Dismissed : Dismissed;

export function modalFn(): <TModal extends Modal2>(
  config: ModalConfig<TModal>
) => Promise<ExtractResult<TModal>> {
  const modalService = inject(ModalService);
  const injector = inject(EnvironmentInjector);
  return (config) => modal(modalService, config, injector);
}
